import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpResponse, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PageURL } from '../pages/pages';
import { AppCacheStorageService } from '../shared/services/storage/app-cache-storage.service';

@Injectable()
export class MaintenanceInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private readonly cache: AppCacheStorageService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  private async handleAccess(request: HttpRequest<any>, next: HttpHandler):
    Promise<HttpEvent<any>> {
      return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // console.log('MAINTENANCE headers--->>>', event.headers);
            if (event.headers.get('x-maintenance') == '1' && this.router.url != PageURL.MAINTENANCE) {
              //console.log('NAVIGATING TO MAINTENANCE')
              if (event.headers.get('RetryTime') && event.headers.get('RetryTime') != '') {
                //console.log('RETRY TIME HEADER PRESENT')
                this.cache.save('RetryTimeMaintenance', event.headers.get('RetryTime'))
              }
              this.router.navigate(['/maintenance']);
            }
            else if(event.headers.get('x-maintenance') != '1' && event.headers.get('x-maintenance') != null && this.router.url == PageURL.MAINTENANCE){
              //console.log('ALREADY ON MAINTENANCE PAGE, ROUTING TO HOME')
              this.cache.save('RetryTimeMaintenance', null)
              this.router.navigate(['/']);
            }
          }
          return event;
        },
        catchError((error: any) => {
          //console.log('MAINTENANCE error', error);
          return throwError(error);
        })
      )).toPromise();
  }
}